import React from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { useSelector,useDispatch } from 'react-redux'
import {
	CHeader,CHeaderBrand,CHeaderNav,CHeaderToggler,CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,CFormInput,CFormTextarea,CInputGroup,CInputGroupText,CFormSelect,
		CButton,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyHeaderProfile,
	MyButton,
	MyDialogformconsent,
	MyDialogpasien,
	MyPagination,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'

const pjson 		= require('../../../package.json')
const Consentpasien = (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;

	//--DOM--/
	const uNavigate 				= useNavigate();
	const uDispatch 				= useDispatch();
	const { tabel_id } 				= useParams(); 
	//--END DOM--/

	const uPasienID					= parseInt(tabel_id)||0;
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);
	const uJenisconsentArr			= useSelector(state => state.gJenisconsentArr);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? 10 : 15;
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uDatacabangArr			= JSON.parse(localStorage.getItem("cabanglist")||"[]");
	const uIsHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	const [uISLoadingawal,setLoadingawal] = React.useState(false);

	const [uDatapasienObj,setDatapasienObj]	= React.useState({});
	//const [uDatadokterArr,setDatadokterArr]	= React.useState([]);
	const [uDatatabelArr,setDatatabelArr]	= React.useState([]);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uRowselectidx,setRowselectidx]= React.useState(-1);
	const uFrameExport 				= document.getElementById("ifmcontentstoprint");

	//--PAGE_DIATUR_BACKEND--/
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const uISInitbefore 				= (JSON.stringify(uLastinitObj||{})!=="{}");
	const [uISBeforeprocess,setISBeforeprocess] = React.useState(false);
	//--END PAGE_DIATUR_BACKEND--*/

	const uPeriksainitObj		= uDatapasienObj.periksa_init || {};
	const uISPeriksainit		= (uPeriksainitObj.userinit === uTokenObj.userinit);
	
	//const uBillingperiksaObj			= useSelector(state => state.gBillingperiksaObj);

	//--DLGLOOKUP--/
	//--END DLGLOOKUP--/

	//--DLG_FORM--/
	//--END DLG_FORM--/

	//--DLG_FORM--/
	const [uDlgformconsentObj,setDlgformconsentObj]		= React.useState({})
	const [uISDlgformconsentshow,setDlgformconsentshow]	= React.useState(false)
	//--END DLG_FORM--/

	//--DLG_PASIEN--/
	const [uISDlgpasienshow,setDlgpasienshow]= React.useState(false)
	const [uDlgPasienID,setDlgPasienID]		= React.useState(uPasienID)
	//--END DLG_PASIEN--/

	//---HANDEL--/
	const hdlKDownDocument = (_EV) => {}
	const hdlKlikBack = () => { 
		setRowselectidx(-1);
		if(uUrlbefore === ""
			|| uISPeriksainit
			) {
			uNavigate(-1); return;
		}
		
		uNavigate(uUrlbefore, {replace:true} );
	}
	const hdlKlikReset = () => {
		if(uHtml500msg) {
			apiLoadawal(); return;
		}

		setDatatabelArr([]);setJmlData(0);setPageActive(1);
		apiLoadtabel();
	}
	const hdlKlikTambah = () => {
		setRowselectidx(-1);

		let vTmpdokterObj = {}
		if(uTokenObj.userhak === "DOKTER") {
			const vDokterID	= parseInt(uTokenObj.user_dokterid)||0;
			vTmpdokterObj = {
				id_dokter: vDokterID,
			}
		}
		const vUrldone 	= window.location.pathname + window.location.search;

		setDlgformconsentObj({
			id_cabang: parseInt(uTokenObj.user_cabangid)||0,
			id_pasien: uPasienID,
			url_done: vUrldone,
			...vTmpdokterObj,
		})
		setDlgformconsentshow(true);
	}
	const hdlKlikRM = () => {
		setRowselectidx(-1);
		uNavigate("/subpasien/pasien/rekammedis/"+uPasienID);
	}
	const hdlKlikFotopasien = () => {
		setRowselectidx(-1);
		uNavigate("/subpasien/pasien/fotopasien/"+uPasienID);
	}
	const hdlKlikDetilpasien = () => {
		setRowselectidx(-1);
		setDlgpasienshow(true);
	}
	const hdlKlikCetak = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;

		const vArridx	= UFunc.getObjectIndeks(uDatatabelArr,_IDTABEL)
		const vRowidx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setRowselectidx(vRowidx);

		if((uDatatabelArr[vArridx].status_loaddetil||"TIDAK")==="YA") {
			prosesCetakconsent(_IDTABEL);
			return;
		}

		apiLoaddetil(_IDTABEL);
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	const prosesCetakconsent = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0;

		const vArridx	= UFunc.getObjectIndeks(uDatatabelArr,_IDTABEL)
		const vContent	= uDatatabelArr[vArridx].content_html || "";
		if(vContent === "") return;

		uFrameExport.srcdoc = vContent;
		uFrameExport.onload = function() {
			uFrameExport.contentWindow.focus();
			uFrameExport.contentWindow.print();
		};
	}
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentHeadersub = () => {
		if(uHtml500msg) return (
		<>
		Page 500
		<CLink onClick={()=>hdlKlikReset()} className="classcursorpointer classikon classikonreset"/>
		</>
		)//>

		if(uISLoadingawal) return (
			<i className="text-primary classblinking mx-auto">Loading...</i>
		)//>

		if(isMobile) return (
		<>
			<div className="">
				<div className="text-info text-uppercase">{uDatapasienObj.pasien_caption}</div>
			</div>

			<div className="w-auto ps-2">
				{!uISPeriksainit && (
				<CLink onClick={()=>hdlKlikTambah()} className="classikon classikontambah classcursorpointer" height={32}/>
				)}

				<CDropdown>
				<CDropdownToggle className="p-0" color="transparent" caret={false}>
					<CIcon icon="cilChevronBottom" className="classikonbox mx-0" height={28}/>
				</CDropdownToggle>

				<CDropdownMenu>
				<CDropdownItem onClick={()=>hdlKlikReset()}>
					<CIcon className="classikonreset mx-0 me-2 align-middle" height={25}/>Reset Tampilan
				</CDropdownItem>

				{!uISPeriksainit && (
				<CDropdownItem onClick={()=>hdlKlikRM()} className="classcursorpointer">
					<CImage src={pjson.homepage+"api/images/icon_rekammedis.png"} className="align-middle mx-0 me-2" height={25}/>
					{(uBahasaObj.caption_lihatrm||"Lihat Rekam Medis")}
				</CDropdownItem>
				)}

				<CDropdownItem onClick={()=>hdlKlikFotopasien()} className="classcursorpointer">
					<CImage src={pjson.homepage+"api/images/icon_foto.png"} className="align-middle mx-0 me-2" height={25}/>
					{(uBahasaObj.caption_fotopasien||"Foto Pasien")}
				</CDropdownItem>

				<CDropdownDivider/>
				<CDropdownItem onClick={()=>hdlKlikDetilpasien()} className="classcursorpointer">
					<CIcon icon="cilFindInPage" className="classikonbox mx-0 me-2" height={25}/>
					{(uBahasaObj.caption_lihatdetilpasien||"Lihat Data Pasien")}
				</CDropdownItem>
				</CDropdownMenu>
				</CDropdown>
			</div>

			<div className="w-100 classborderbottom my-2"/>

			<div className="w-100 classfontsmaller">
				<span className="fw-bolder" style={{color:((uDatapasienObj.sex||"")==="P"?"pink":"navy")}}>
					[{uDatapasienObj.sex}]
				</span>
				<span> &middot; </span>
				<span className="">{uDatapasienObj.umur}</span>
			</div>
		</>
		)//>

		return (
		<>
			<div className="w-75">
				<b className="text-info text-uppercase">{uDatapasienObj.pasien_caption}</b>
				<span> &middot; </span>
				<small className="fw-bolder" style={{color:((uDatapasienObj.sex||"")==="P"?"pink":"navy")}}>[{uDatapasienObj.sex}]</small>
				<span> &middot; </span>
				<small className="">{uDatapasienObj.umur}</small>
			</div>

			<div className="w-25 text-center px-2">
				{!uISPeriksainit && (
				<>
				<CTooltip className="d-none d-lg-block" content="--Create Consent Baru">
				<CLink onClick={()=>hdlKlikTambah()} className="classikon classikontambah classcursorpointer" style={{height:35,width:35}}/>
				</CTooltip>

				<span className="me-1">&middot;</span>
				</>
				)}
				
				<CTooltip className="d-none d-lg-block" content={"--"+(uBahasaObj.caption_resetview||"Refresh Tampilan")}>
				<CLink onClick={()=>hdlKlikReset()} className="classikontabel classikonreset classcursorpointer"/>
				</CTooltip>
				
				<span className="me-1">&middot;</span>

				<CDropdown>
				<CDropdownToggle className="p-0" color="transparent" caret={false}>
					<CIcon icon="cilChevronBottom" className="classikonbox mx-0" height={25}/>
				</CDropdownToggle>

				<CDropdownMenu>
				{!uISPeriksainit && (
				<CDropdownItem onClick={()=>hdlKlikRM()} className="classcursorpointer">
					<CImage src={pjson.homepage+"api/images/icon_rekammedis.png"} className="align-middle mx-0 me-2" height={25}/>
					{(uBahasaObj.caption_lihatrm||"Lihat Rekam Medis")}
				</CDropdownItem>
				)}

				<CDropdownItem onClick={()=>hdlKlikFotopasien()} className="classcursorpointer">
					<CImage src={pjson.homepage+"api/images/icon_foto.png"} className="align-middle mx-0 me-2" height={25}/>
					{(uBahasaObj.caption_fotopasien||"Foto Pasien")}
				</CDropdownItem>

				<CDropdownDivider/>
				<CDropdownItem onClick={()=>hdlKlikDetilpasien()} className="classcursorpointer">
					<CIcon icon="cilFindInPage" className="classikonbox mx-0 me-2" height={25}/>
					{(uBahasaObj.caption_lihatdetilpasien||"Lihat Data Pasien")}
				</CDropdownItem>
				</CDropdownMenu>
				</CDropdown>
			</div>
		</>
		)//>
	}
	const contentConsentdata = () => {
		if(uHtml500msg) return "";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;

		//--PAGE_DIATUR_BACKEND--/
		const vDataviewArr	= uDatatabelArr.filter(vItems => 
			parseInt(vItems.pg||1) === parseInt(uPageActive));
		//--END PAGE_DIATUR_BACKEND--*/

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row align-top text-center classfontsmaller">
			<th width={30} className="px-1"><small>No</small></th>
			
			<th className="px-0">
				<CRow className="mx-0">
				<CCol md="2" className="px-1 text-start"><small>Tgl Consent</small></CCol>
				<CCol md="4" className="px-1 text-start"><small>Nama Tindakan</small></CCol>
				<CCol md="3" className="px-1 text-start"><small>Jenis Consent</small></CCol>
				<CCol md="2" className="px-1 text-start"><small>Nama Dokter</small></CCol>
				<CCol md="1" className="px-1"><small>&middot;</small></CCol>
				</CRow>
			</th> 
			</tr>

			<tr className="d-md-none classfontsmaller">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{uDatatabelArr.map((vItems,vKeys)=>{
			const {
				tgl_consent,id_cabang,nama_cabang,id_jenis_consent,
				titel_jenis_consent,nama_tindakan,id_dokter,nama_dokter,
				tgl_input, user_input, is_loading,
				id,
			} = vItems;

			vNumber++;
			const vCaptionupper	= UFunc.TglAngka(tgl_consent).toUpperCase();

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uRowselectidx===vKeys?" classrowselect":"")}>
			<td className="px-1">{vNumber}.</td>

			<td className="px-1 px-md-0">
			<CRow className="mx-0">
				<CCol md="2" className="px-1 d-none d-md-block text-md-start">
					<div>{UFunc.TglAngka(tgl_consent)}</div>
					<div className="classfontsmaller">
						<small>[
						<span className="text-primary">{UFunc.Usercaptionfilter(nama_cabang)}</span>
						<span> &middot; </span>
						<span className="text-danger">{UFunc.Usercaptionfilter(user_input)}</span>
						]</small>
					</div>
				</CCol>

				<CCol xs="12" md="4" className="px-1 text-md-start">
					<div className="d-flex justify-content-between">
					<b className="text-info text-capitalize">{nama_tindakan||"Undf Tindakan"}</b>

					{(uTokenObj.userhak !== "DOKTER"
						|| (uTokenObj.userhak === "DOKTER" && parseInt(id_dokter)===parseInt(uTokenObj.user_dokterid))
						)&& (
					<div className="d-md-none">
						{(is_loading||false)===true ? (
							<CSpinner size="sm" color="primary"/>
						) : (
							<CTooltip content="--Cetak-PDF Informed Consent">
							<CLink onClick={()=>hdlKlikCetak(id)} className="classcursorpointer classikontabel classikoncetak"/>
							</CTooltip>
						)}
					</div>
					)}
					</div>
				</CCol>

				<CCol xs="12" className="px-1 d-flex d-md-none justify-content-between">
					<small>{UFunc.TglAngka(tgl_consent)}</small>
					<div className="classfontsmaller ps-1">
						<small>[
						<span className="text-primary">{UFunc.Usercaptionfilter(nama_cabang)}</span>
						<span> &middot; </span>
						<span className="text-danger">{UFunc.Usercaptionfilter(user_input)}</span>
						]</small>
					</div>
				</CCol>

				<CCol xs="12" className="px-1 d-md-none classborderbottom my-3"/>

				<CCol xs="4" className="px-1 d-md-none text-start"><small>Jenis Consent</small></CCol>
				<CCol xs="8" md="3" className="px-1 text-md-start">{titel_jenis_consent||"Titel Jenis Consent"}</CCol>
				
				<CCol xs="4" className="px-1 d-md-none text-start"><small>Nama Dokter</small></CCol>
				<CCol xs="8" md="2" className="px-1 text-md-start fw-bolder">{UFunc.Usercaptionfilter((nama_dokter||"Undf Dokter"),2)}</CCol>
				
				<CCol md="1" className="px-1 text-md-center d-none d-md-block">
					{(uTokenObj.userhak !== "DOKTER"
						|| (uTokenObj.userhak === "DOKTER" && parseInt(id_dokter)===parseInt(uTokenObj.user_dokterid))
						) ? (
					<>
					{(is_loading||false)===true ? (
						<CSpinner size="sm" color="primary"/>
					) : (
						<CTooltip content="--Cetak-PDF Informed Consent">
						<CLink onClick={()=>hdlKlikCetak(id)} className="classcursorpointer classikontabel classikoncetak"/>
						</CTooltip>
					)}
					</>
					) : (<>&middot;</>)}
				</CCol>
			</CRow>
			</td>
			</tr>
			)//>
		})}
		</tbody>
		</table>
		)//>
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoadawal = async() => {
		setHtml500msg();
		setDatapasienObj({});
		setDatatabelArr([]);
		setLoadingawal(true);
		setLoading(true);
		try {
			setSessionaktif(false);
			const vPage			= uLastinitObj ? parseInt(uLastinitObj.initPage||1) : 1;
			const vHeaderObj = {
				headers: { Accept: "application/json", "Content-Type": "application/json" },
				method: "POST",
				mode: "cors",
				cache: "default",
			}

			setPageActive(vPage);

			setTimeelapse(0);
			const vTimeBegin = new Date();
			const [output_main,output_tabel] = await Promise.all([
				(async () => {
					const vURLs	= pjson.homepage+"api/api_rekammedis/ld_data";
					const vDATAS= JSON.stringify({
						send_pasienid : uPasienID,
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})(),
				(async () => {
					const vURLs	= pjson.homepage+"api/api_consent/ld_datapasien";
					const vDATAS= JSON.stringify({
						send_pasienid: uPasienID,
						send_page: vPage,
						send_jmlperpage: uMaxData,
						send_loadjml: "YA",
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})(),
				
				/*(async () => {
					const vURLs	= pjson.homepage+"api/api_dokter/ld_dokterlookup";
					const vDATAS= JSON.stringify({
						send_tokenauth : uTokenObj.userinit
					});
					const response = await fetch(vURLs,{...vHeaderObj,body:vDATAS});
					if (!response.ok) throw new Error('Network response MAIN was not ok.');
					return response.json();
				})(),//-*/
			]);

			setSessionaktif(true);

			//--DATA_MAIN--/
			if(output_main.tampil) {
				setDatapasienObj(JSON.parse(output_main.datapasien || "{}"));
			} else if(output_main.info) {
				setHtml500msg(output_main.info);
			} else if(output_main.errors) {
				console.log("(Consentpasien - apiLoadawal) output_main.errors : "+output_main.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_main.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_main.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DATA_MAIN--/

			//--DATA_TABEL--/
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setTimeelapse(vTimeDiff);
			if(output_tabel.tampil) {
				//console.log("(Consent - apiLoadawal) output_tabel.dataobject : "+(output_tabel.dataobject));
				const vTmpArr = JSON.parse(output_tabel.dataobject||"[]");

				//--PAGE_DIATUR_BACKEND--/
				vTmpArr.map(vItems=>vItems.pg = vPage);
				setDatatabelArr([...vTmpArr]);

				if(output_tabel.totaldata)
					setJmlData(parseInt(output_tabel.totaldata)||0);

		    	if(uISInitbefore) setISBeforeprocess(true);
				//--END PAGE_DIATUR_BACKEND--*/

				/*//--PAGE_DIATUR_FRONTEND--/
				setDatatabelArr(vTmpArr);
				//--END PAGE_DIATUR_FRONTEND--*/

			} else if(output_tabel.info) {
				setHtml500msg(output_tabel.info);
			} else if(output_tabel.errors) {
				console.log("(Consentpasien - apiLoadawal) output_tabel.errors : "+output_tabel.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_tabel.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_tabel.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DATA_TABEL--/

			/*//--DATA_DOKTER--/
			if(output_dokter.tampil) {
				//console.log("(Consent - apiLoadawal) uPageActive : "+(uPageActive));
				const vTmpArr = JSON.parse(output_dokter.datadokter||"[]");
				setDatadokterArr(vTmpArr);
			} else if(output_dokter.info) {
				setHtml500msg(output_dokter.info);
			} else if(output_dokter.errors) {
				console.log("(Consentpasien - apiLoadawal) output_dokter.errors : "+output_dokter.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_dokter.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_dokter.expired) {
				setLoading(true); prosesExpired(); return;
			}
			//--END DATA_DOKTER--*/
		} catch (error) {
			console.log("(Consentpasien - apiLoadawal) catch-error : "+error.message);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		} finally {
			setLoading(false);
			setLoadingawal(false);
		}
	}
	const apiLoadtabel = (_PAGE) => {
		const vPage	= parseInt(_PAGE)||1;
		setHtml500msg();

		//--PAGE_DIATUR_BACKEND--/
		let vDatamainArr	= uDatatabelArr;
		if(vDatamainArr.length >= 10000) {
			vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.pg||1) === 1);
		} else
			vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.pg||1) !== uPageActive);
		//--END PAGE_DIATUR_BACKEND--*/

		/*//--PAGE_DIATUR_FRONTEND--/
		setDatatabelArr([]);
		setJmlData(0);
		setRowselectidx(-1);
		setPageActive(1);
		//--PAGE_DIATUR_FRONTEND--*/

		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_pasienid: uPasienID,
			send_page: vPage,
			send_jmlperpage: uMaxData,
			send_loadjml: (JSON.stringify(uLastinitObj||{}) !== "{}" || !_PAGE) ? "YA" : "TIDAK",
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_consent/ld_datapasien";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Consent - apiLoaddata) uPageActive : "+(uPageActive));
				const vTmpArr = JSON.parse(output_string.dataobject||"[]");

				//--PAGE_DIATUR_BACKEND--/
				vTmpArr.map(vItems=>vItems.pg = vPage);
				setDatatabelArr([...vDatamainArr,...vTmpArr]);

				if(output_string.totaldata)
					setJmlData(parseInt(output_string.totaldata)||0);

		    	if(uISInitbefore) setISBeforeprocess(true);
				//--END PAGE_DIATUR_BACKEND--*/

				/*//--PAGE_DIATUR_FRONTEND--/
				setDatatabelArr(vTmpArr);
				//--END PAGE_DIATUR_FRONTEND--*/

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Consentpasien - apiLoadtabel) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Consentpasien - apiLoadtabel) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiLoaddetil = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL)||0; if(_IDTABEL <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDatatabelArr,_IDTABEL)
		uDatatabelArr[vArridx] = {...(uDatatabelArr[vArridx]||{}),
			is_loading: true,
		}

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			setEfekview(!uEfekview);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_consent/ld_detil";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.tampil) {
				const vContenthtml 	= output_string.contenthtml_str || "";
				const vTmpurlArr	= JSON.parse(output_string.urlimgarr_str || "[]");

				uDatatabelArr[vArridx] = {...(uDatatabelArr[vArridx]||{}),
					is_loading: false,
					status_loaddetil: "YA",
					content_html: vContenthtml,
				}
				//console.log("(Consent - apiLoaddetil) vTmpurlArr : ",vTmpurlArr);

				//--CACHING_IMG--/
				Promise.all(vTmpurlArr.map(src => {
					const img = new Image();
					img.src = src;
					return img.decode();
				})).finally(() => prosesCetakconsent(_IDTABEL) );
				//--END CACHING_IMG--/
			} else {
				uDatatabelArr[vArridx] = {...(uDatatabelArr[vArridx]||{}),
					is_loading: false,
				}

				if(output_string.info) {
					showToast(output_string.info);
				} else if(output_string.errors) {
					console.log("(Consentpasien - apiLoaddetil) output_string.errors : "+output_string.errors);
					const vMsg = (pjson.mydefault.environment==="development")
						? output_string.errors : pjson.mydefault.msgFetchError;
					showToast(vMsg,"ERROR");
				} else if(output_string.expired) {
					setLoading(true); prosesExpired();
				}
			}
		})
		.catch((error) =>{
			uDatatabelArr[vArridx] = {...(uDatatabelArr[vArridx]||{}),
				is_loading: false,
			}
			console.log("(Consentpasien - apiLoaddetil) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{
		document.addEventListener("keydown",hdlKDownDocument);

		return ()=>{
			document.removeEventListener("keydown",hdlKDownDocument);
		}
	})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gConsentcreateObj: undefined});
    	
    	apiLoadawal();

    	//console.log("(Consentpasien - []) uBillingperiksaObj => ",uBillingperiksaObj);

    	return () => {
    		setDatapasienObj({}); setDatatabelArr([]);
			setDlgformconsentshow(false); 
    	}
	},[])
	React.useEffect(()=>{
		if(!uISInitbefore) return;

		const vPageinit	= parseInt(uLastinitObj.initPage)||1;
		setPageActive(vPageinit); apiLoadtabel(vPageinit);
	},[uISInitbefore]);
	React.useEffect(()=>{
		if(!uISBeforeprocess) return;

		const vInitID	= uLastinitObj.initID;
		
		const vElscroll	= document.getElementById("idtr"+(vInitID||0));
		const vRectdimensi = vElscroll && (vElscroll.getBoundingClientRect());
		vRectdimensi && (window.scrollTo({ top: (vRectdimensi.top||0) - 150, behavior: "smooth" }))
		//console.log("(Requestorder - [uLastinitObj]) vRectdimensi => "+JSON.stringify(vRectdimensi))

		setISBeforeprocess(false)
		uDispatch({type: "set", gInitTabelSelected: {}}); 
	},[uISBeforeprocess]);
	React.useEffect(()=>{ 
		setRowselectidx(-1); 

		//--PAGE_DIATUR_BACKEND--/
    	if(JSON.stringify(uLastinitObj||{}) !== "{}") return;
    	if(uPageActive <= 0) { setPageActive(1); return }

		const vDataviewArr	= uDatatabelArr.filter(vItems=>parseInt(vItems.pg||1) === parseInt(uPageActive));
		if(vDataviewArr.length > 0) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}
		apiLoadtabel(uPageActive);
		//--END PAGE_DIATUR_BACKEND--*/
	},[uPageActive])
	React.useEffect(()=>{ 
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);
	},[uJmlData])
	React.useEffect(()=>{
		if(!uISDlgformconsentshow) 
			{ setDlgformconsentObj({}); return }
	},[uISDlgformconsentshow])
	//---END EFFECT--/

	//console.log("(Consentpasien) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-3 p-0">
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler className="px-0" onClick={() => hdlKlikBack() }>
			<CIcon icon="cilArrowCircleLeft" className="align-top me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderBrand className="me-auto text-normal">
				<b>Informed Consent Pasien</b>
			</CHeaderBrand>

			<CHeaderNav>
				<MyHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>

		<CContainer fluid className="bg-white p-2 px-3" style={{minHeight:52}}>
			{contentHeadersub()}
		</CContainer>
		</CHeader>

		<div className="body flex-grow-1 px-2 px-lg-5 mb-3">
		<CContainer xxl className="px-0">
			{(uHtml500msg) ? (
			<CCard className="classbgcard mb-2">
			<CCardHeader>Error Page 500</CCardHeader>
			<CCardBody>
				<div className="mx-3">{UFunc.renderHTML(uHtml500msg)}</div>
			</CCardBody>
			</CCard>
			) : (
			<>
			<CCard className="classbgcard mb-3">
			<CCardHeader className="classfontsmaller d-flex justify-content-between">
				<div>
				<span >Data Consent Pasien</span>
				<span> &middot; </span>
				<span>[<b>{uJmlData}</b>]</span>
				</div>

				<small className="text-muted">{uTimeelapse}ms</small>
			</CCardHeader>
			
			<CCardBody className="px-0">{contentConsentdata()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
				<MyPagination 
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i)=>setPageActive(i)}
					align="start"/> 
			</CCardFooter>
			)}
			</CCard>
			</>
			)}
		</CContainer>
		</div>
		</div>

		<MyDialogformconsent
			show={uISDlgformconsentshow} 
			cabangid={uDlgformconsentObj.id_cabang}
			pasienid={uDlgformconsentObj.id_pasien}
			dokterid={uDlgformconsentObj.id_dokter}
			urldone={uDlgformconsentObj.url_done}
			toggle={()=>setDlgformconsentshow(false)}
			{...props}/>

		<MyDialogpasien show={uISDlgpasienshow}
			pasienID={uDlgPasienID}
			toggle={()=>setDlgpasienshow(false)}
			{...props}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		</>
	)//>
}	

export default Consentpasien